import React, { memo } from 'react';
export const ProductReveal = () => {
  return <section className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6" data-id="element-127" data-mp="8oi6gceqpcj9">
      <h2 className="font-bold text-2xl md:text-3xl mt-12 mb-6 text-gray-900" data-id="element-128" data-mp="2r6vfakj3j10v">
        Meet{' '}
        <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-129" data-mp="35zyyewcc5mtp">
          VelaSleep™
        </a>
        : The Cervical Decompression Design™ Pillow
      </h2>

      <p data-id="element-130" data-mp="2defg5utbfn58">
        <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-131" data-mp="2ddw06jn878tu">
          VelaSleep
        </a>{' '}
        was designed around one simple idea: Support the neck separately from
        the head.
      </p>

      <figure className="my-8" data-id="element-132" data-mp="2n4ib40jzzb67">
        <img src="https://cdn.magicpatterns.com/uploads/rDqEd4kwLWqMZJzYG19nXf/How_it_works.jpg" alt="VelaSleep Construction" className="w-full rounded-sm shadow-sm" data-id="element-133" data-mp="2icqt4eewqdro" />
        <figcaption className="text-sm text-gray-500 mt-3 text-center" data-id="element-134" data-mp="1po1s0fduq8fx">
          The unique architecture of{' '}
          <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-135" data-mp="1b1qv5zak2srf">
            VelaSleep
          </a>
          .
        </figcaption>
      </figure>

      <p data-id="element-136" data-mp="1f06e9s3ingzk">
        Its ergonomic contour helps create a more neutral sleeping position
        while premium memory foam adapts to your body for personalized comfort.
      </p>
      <p data-id="element-137" data-mp="1oru982za7g5s">
        Unlike traditional pillows that flatten and shift throughout the night,{' '}
        <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-138" data-mp="s3o299ew0boc">
          VelaSleep
        </a>{' '}
        helps maintain consistent support where it matters most.
      </p>

      <h3 className="font-bold text-xl md:text-2xl mt-10 mb-4 text-gray-900" data-id="element-139" data-mp="11200nxlzwdrc">
        Why It's Different
      </h3>
      <ul className="text-lg list-disc pl-6 space-y-2" data-id="element-140" data-mp="163fjrk4m4a73">
        <li data-id="element-141" data-mp="2cig9h831nw58">
          <strong data-id="element-142" data-mp="2cgve5g8wo96b">Cervical Decompression Design™</strong>
        </li>
        <li data-id="element-143" data-mp="2hgrixhpfg4mx">
          <strong data-id="element-144" data-mp="2hgi14hejd3sb">Neck Support Channel</strong>
        </li>
        <li data-id="element-145" data-mp="2hj49gj993nbl">
          <strong data-id="element-146" data-mp="1rsvu6a05qzfw">Pressure-Relieving Memory Foam</strong>
        </li>
        <li data-id="element-147" data-mp="1rr18gth2b3ar">
          <strong data-id="element-148" data-mp="1ruytxlr446xt">Side & Back Sleeper Compatible</strong>
        </li>
        <li data-id="element-149" data-mp="1mszqkbvdha0v">
          <strong data-id="element-150" data-mp="1mtj8hsl0vyew">Breathable Construction</strong>
        </li>
        <li data-id="element-151" data-mp="21rboeluheotm">
          <strong data-id="element-152" data-mp="21q0fy8q3csw6">Maintains Shape Night After Night</strong>
        </li>
      </ul>
    </section>;
};